import {
  SimulatorResult,
  GetApplicationsQueryResult,
  AttachmentResult,
} from '@sdir/httpclient/lib/clients/aps/application';
import { createContext } from 'react';
import { Loadable } from '../../types';

export interface ICurrentApplicationContext {
  application: Loadable<GetApplicationsQueryResult>;
  qualifications: Loadable<SimulatorResult>;
  /**
   * Henter søknaden på nytt.
   *
   * `keepResult` beholder forrige svar mens det nye hentes — se
   * `CurrentApplicationProvider`. Uten flagget oppfører oppfriskningen seg som
   * før: `loading` settes, `result` nulles, og flatene som er tegnet av søknaden
   * avmonteres.
   */
  refresh?: (keepResult?: boolean) => void;
  loadQualifications?: () => void;
  getAttachment?: (attachment: AttachmentResult) => Promise<File>;
}

export const CurrentApplicationContext = createContext<ICurrentApplicationContext>({
  application: {
    loading: false,
    result: null,
    error: null,
  },
  qualifications: {
    loading: false,
    result: null,
    error: null,
  },
});
